let modelData = [
    {
        modelPics: ['1.jpg', '2.jpg', '3.jpg'],
        modelName: '💥 EMMA 💥',
        modelAge: 25,
        modelSituation: 'Before our partnership she only had a few fans and didn’t know how to gain more fans. Her account stagnated and didn’t grow.',
        modelProfit: 10000,
        modelFans: 2000,
        modelTime: '90 minutes',
    },
    {
        modelPics: ['4.jpg', '6.jpg', '5.jpg'],
        modelName: 'Lana 🐰❤️',
        modelAge: 21,
        modelSituation: 'Lana struggled to grow her fanbase and make a steady income. Despite her efforts, her account remained stagnant, and she didn’t know how to attract more fans or increase her earnings.',
        modelProfit: 8000,
        modelFans: 1500,
        modelTime: '90 minutes',
    },
    {
        modelPics: ['7.jpg', '8.jpg', '9.jpg'],
        modelName: 'Nika ☀️🍋💊',
        modelAge: 27,
        modelSituation: 'Nika struggled to grow her audience and boost her earnings. Despite her efforts, her account remained stagnant, and she wasn’t sure how to attract more fans or scale her income',
        modelProfit: 300,
        modelFans: 4000,
        modelTime: '2 hours',
    }
]

function ModelsDescription() {

    let mappedModels = modelData.map((model, index) => {

        let imagePath1 = require(`../../assets/models/${model.modelPics[0]}`);
        let imagePath2 = require(`../../assets/models/${model.modelPics[1]}`);
        let imagePath3 = require(`../../assets/models/${model.modelPics[2]}`);

        let altText = `Image of ${model.modelName}`;
        
        if(index % 2 === 0){
            return (
                <>
                    <div className="flex-item-model-wrapper">
                        <div className="left-part">
                            <div className="model-photos">
                                <img src={imagePath1} alt={altText} className="model-image1"/>
                                <img src={imagePath2} alt={altText} className="model-image2"/>
                                <img src={imagePath3} alt={altText} className="model-image3"/>
                            </div>
                        </div>
                        <div className="right-part">
                            <div className="info">
                                <div className="subheading">
                                    Before working with us:
                                </div>
                                <div className="model-situation">
                                    {model.modelSituation}
                                </div>
                            </div>

                            <div className="info">
                                <div className="subheading">
                                    Since the beginning of our cooperation
                                </div>
                                <ul className="points">
                                    <li className="model-profit">
                                        <span className="color">💸 Increase in monthly NET profit:</span>
                                        &nbsp;{model.modelProfit} $</li>
                                    <li className="model-fans">
                                        <span className="color">🚀 New fans:</span>
                                        &nbsp;~{model.modelFans} new fans per month</li>
                                    <li className="model-time">
                                        <span className="color">⌚️ Time investment per day:</span> 
                                        &nbsp;{model.modelTime}</li>
                                </ul>
                            </div>

                            <div className="model-short">{model.modelName}, {model.modelAge} years old</div>
                        </div>
                    </div>  
                </>
            )
        }
        
        return(
            <>
                <div className="flex-item-model-wrapper">
                    <div className="left-part">
                        <div className="info">
                            <div className="subheading">
                                Before working with us:
                            </div>
                            <div className="model-situation">
                                {model.modelSituation}
                            </div>
                        </div>

                        <div className="info">
                            <div className="subheading">
                                Since the beginning of our cooperation
                            </div>
                            <ul className="points">
                                <li className="model-profit">
                                    <span className="color">💸 Increase in monthly NET profit:</span>
                                    &nbsp;{model.modelProfit} $</li>
                                <li className="model-fans">
                                    <span className="color">🚀 New fans:</span>
                                    &nbsp;~{model.modelFans} new fans per month</li>
                                <li className="model-time">
                                    <span className="color">⌚️ Time invest per day:</span> 
                                    &nbsp;{model.modelTime}</li>
                            </ul>
                        </div>

                        <div className="model-short">{model.modelName}, {model.modelAge} years old</div>
                    </div>
                    <div className="right-part">
                        <div className="model-photos">
                            <img src={imagePath1} alt={altText} className="model-image1"/>
                            <img src={imagePath2} alt={altText} className="model-image2"/>
                            <img src={imagePath3} alt={altText} className="model-image3"/>
                        </div>
                    </div>
                </div>  
            </>
        )

    });

    return ( 
        <>
            <section className="models-description">
                <div className="container">
                    <div className="flex-column">
                        {mappedModels} 
                    </div>
                </div>
            </section>
        </>
     );
}

export default ModelsDescription;